import React, { useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from 'react-router-dom';

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <div style={{ fontSize: "4rem" }}>😞</div>
        <h1 className="text-danger">Payment Failed</h1>
        <p>Something went wrong. Please try again or contact support.</p>
        <small>You will be redirected to the homepage shortly...</small>
        </div>
    </div>
  );
};

export default ErrorPage;
